import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";
import DatePicker from "../../../components/date-picker/DatePicker";

interface Prop {
  onClose: () => void;
  id?: any;
}
const MarriageForm: React.FC<Prop> = ({ onClose, id }) => {
  const [formData, setFromData] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [initialFromData, setInitialFromData] = useState<any>();
  const handleAdd = async () => {
    try {
      const resp = await axiosInstance.post("/api/marriage", formData);
      if (resp?.status === 200) {
        toast.success("Marriage Created Successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleEdit = async () => {
    try {
      const resp = await axiosInstance.put(`/api/marriage/${id}`, formData);
      if (resp?.status === 200) {
        toast.success("Marriage Updated Successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleGet = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/marriage/${id}`);
      if (resp.status === 200) {
        resp.data.data.husband = resp?.data?.data?.man?.id;
        resp.data.data.wife = resp?.data?.data?.woman?.id;

        setFromData(resp?.data?.data);
        setInitialFromData(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };

  const handleGetUsers = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/user?search=`);
      if (resp.status === 200) {
        setUserData(resp?.data?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };

  const handleChage = (field: string, value: string) => {
    setFromData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!formData?.husband) {
      toast.error("Husband is required");
      return;
    }
    if (!formData?.wife) {
      toast.error("Wife is required");
      return;
    }
    if (formData?.husband === formData?.wife) {
      toast.error("Husband and Wife cannot be the same");
      return;
    }
    if (!formData?.solemnized_date) {
      toast.error("Solemnized Date is required");
      return;
    }

    if (formData?.is_dissolved && !formData?.dissolution_date) {
      toast.error("Dissolution Date is required when marriage is dissolved");
      return;
    }
    if (id) {
      const noFieldChanges =
        JSON.stringify(initialFromData) === JSON.stringify(formData);
      if (noFieldChanges) {
        toast.info("No changes were made");
        return;
      }
    }

    // if (!formData?.block_name) {
    //   toast.error("Block name is reqiured ");
    //   return;
    // }
    if (id) {
      await handleEdit();
    } else {
      await handleAdd();
    }
  };
  useEffect(() => {
    id && handleGet(id);
    handleGetUsers();
  }, []);

  console.log(formData);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {id ? "Edit Marriage" : " Add Marriage"}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Husband <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <Select
              size="small"
              value={formData?.husband ? formData?.husband : 0}
              onChange={(e: any) => handleChage("husband", e?.target?.value)}
            >
              {userData?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Wife <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <Select
              size="small"
              value={formData?.wife ? formData?.wife : 0}
              onChange={(e: any) => handleChage("wife", e?.target?.value)}
            >
              {userData?.map((item: any) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Solemnized Date
              <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <DatePicker
              value={formData?.solemnized_date || ""}
              onChange={(date) => handleChage("solemnized_date", date)}
              placeholder="Select solemnized date"
              className="w-full"
            />
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Solemnized Place
              <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <TextField
              size="small"
              variant="outlined"
              value={formData?.solemnized_place || ""}
              onChange={(e) => handleChage("solemnized_place", e.target.value)}
            />
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Is Dissolved</FormLabel>
            <FormControlLabel
              control={
                <Switch
                  checked={!!formData?.is_dissolved}
                  onChange={(e: any) =>
                    handleChage("is_dissolved", e?.target?.checked)
                  }
                />
              }
              label={formData?.is_dissolved ? "Yes" : "No"}
            />
          </Box>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Dissolution Date</FormLabel>
            <DatePicker
              value={formData?.dissolution_date || ""}
              onChange={(date) => handleChage("dissolution_date", date)}
              placeholder="Select dissolution date"
              className="w-full"
            />
          </Box>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"end"}>
          {" "}
          <Box display={"display"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default MarriageForm;
